'use client'

import dynamic from 'next/dynamic'

export const RecommendationInactivityModalDynamic = dynamic(
  async () =>
    import('./RecommendationInactivityModal').then(
      (mod) => mod.RecommendationInactivityModal,
    ),
  {
    ssr: false,
  },
)
